export const updateOrgStructure = (payload?: any) => ({
    type: "@saga/UPDATE_ORGSTRUCTURE",
    payload
});

